<div class="rounded-md bg-orange-lighter p-2 mt-4 max-w-lg">
	<div class="flex items-center justify-between gap-4">
		<app-icon
			[icon]="ICON.WARNING"
			class="text-orange"
			[testHook]="testHooks.WarningIcon"
		></app-icon>
		<p>
			<span class="font-bold">Missing fields: </span>Complete the missing fields
			to return to the portal
		</p>
		<div
			class="flex items-center cursor-pointer gap-2"
			(click)="toggleShowFields()"
			[testHook]="testHooks.ToggleShowFieldsDiv"
		>
			<p class="font-bold" *ngIf="!showFields">Show</p>
			<p class="font-bold" *ngIf="showFields">Hide</p>
			<app-icon
				class="text-sm"
				[icon]="showFields ? ICON.UP : ICON.DOWN"
				[testHook]="testHooks.DownIcon"
			></app-icon>
		</div>
	</div>
	<div
		*ngIf="showFields"
		[@openClose]
		class="mt-4 rounded-md p-4 bg-orange-lighter"
	>
		<div class="items-center text-center" *ngFor="let fieldSection of missing">
			<p class="my-1 font-bold">{{ fieldSection.sectionName }}</p>
			<div
				*ngFor="let field of fieldSection.fields"
				class="flex mt-2 items-center justify-center text-center"
			>
				<app-icon
					[icon]="ICON.ERROR"
					class="text-red mr-3"
					[testHook]="testHooks.ErrorIcon"
				></app-icon>
				<ng-container>
					<app-anchor
						(click)="field?.url || field?.openDrawer()"
						[url]="field?.url"
						[queryParams]="field.queryParams ?? backUrlParams"
						type="static"
						[testHook]="testHooks.Link"
						>{{ field.fieldName }}</app-anchor
					>
				</ng-container>
			</div>
		</div>
	</div>
</div>
